import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const productService = {
  // Get all products
  getAllProducts: () => api.get('/products/'),
  
  // Get products by category
  getProductsByCategory: (category) => api.get(`/products/?category=${category}`),
  
  // Get single product by ID
  getProductById: (id) => api.get(`/products/${id}`),
  
  // Get featured products using the dedicated endpoint
  getFeaturedProducts: async () => {
    try {
      const response = await api.get('/products/featured/');
      return response.data;
    } catch (error) {
      console.error('Error fetching featured products:', error);
      throw error;
    }
  }
};

export const contactService = {
  // Submit contact form
  submitContactForm: async (formData) => {
    try {
      const response = await api.post('/contact/', formData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  }
};

export const memberService = {
  getAllMembers: () => api.get("/members/"),
};


export default api;
